import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import Checkbox from "components/DesignComponents/Checkbox";
import AuthContext from "context/auth/authContext";

import { ClearTasksAndHistoryProps } from "./types";

const ClearTasksAndHistory = ({
    isChecked,
    onChange
}: ClearTasksAndHistoryProps) => {
    const { isSupportUser } = useContext(AuthContext);

    const { t } = useTranslation();

    return (
        <>
            {isSupportUser && (
                <BannerView
                    bannerType={BannerType.Info}
                    title={t("Dialog##clear device history banner")}
                />
            )}

            <Checkbox
                label={t("Dialog##delete tasks and history")}
                checked={isChecked}
                onChange={(_, value) => onChange(value)}
                customStyle={{
                    margin: "16px 0"
                }}
            />
        </>
    );
};

export default ClearTasksAndHistory;
